<template>
  <div
    :class="['table-components x-flex-y', { 'remove-header-bg': removeHeaderBg }]"
    data-automation="table"
  >
    <el-table
      ref="elTable"
      :data="tableData"
      :class="['x-flex-y', { 'x-border-color': xborder }]"
      :max-height="maxHeight"
      :height="height"
      :empty-text="emptyText"
      :highlight-current-row="highlightCurrentRow"
      :row-class-name="rowClassName"
      :row-key="rowKey"
      :tree-props="treeProps"
      @select="select"
      @select-all="selectAll"
      @selection-change="selectionChange"
      @row-click="rowClick"
    >
      <template v-for="(item, key) in columns">
        <template v-if="!item.hidden">
          <el-table-column
            v-if="item.header"
            :prop="item.prop"
            :width="item.width"
            :min-width="item.minWidth"
            :align="item.align || 'center'"
            :fixed="item.fixed"
            :show-overflow-tooltip="item.tooltip"
            :formatter="item.formatter"
          >
            <Cell
              slot="header"
              slot-scope="scope"
              :row="scope.row"
              :index="scope.$index"
              :render="item.header"
            ></Cell>
            <Cell
              v-if="item.render"
              slot-scope="scope"
              :row="scope.row"
              :index="scope.$index"
              :render="item.render"
            ></Cell>
          </el-table-column>
          <el-table-column
            v-else-if="item.render"
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
            :min-width="item.minWidth"
            :align="item.align || 'center'"
            :fixed="item.fixed"
            :show-overflow-tooltip="item.tooltip"
            :formatter="item.formatter"
          >
            <Cell
              slot-scope="scope"
              :row="scope.row"
              :index="scope.$index"
              :render="item.render"
            ></Cell>
          </el-table-column>
          <el-table-column
            v-else-if="item.type"
            :type="item.type"
            :label="item.label"
            :selectable="item.selectable"
            :width="item.width"
            :min-width="item.minWidth"
            align="center"
            :fixed="item.fixed"
          ></el-table-column>
          <el-table-column
            v-else
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
            :min-width="item.minWidth"
            :align="item.align || 'center'"
            :fixed="item.fixed"
            :show-overflow-tooltip="item.tooltip"
            :formatter="item.formatter"
          ></el-table-column>
        </template>
      </template>
    </el-table>
    <div class="pagination" v-if="showPage && !showMin">
      <div class="total-box">
        <i>{{ $t('HT.table.all') }}</i>
        <i class="total">{{ total }}</i>
        <i>{{ $t('HT.table.record') }}</i>
      </div>
      <el-pagination
        background
        :total="total"
        :page-sizes="sizes"
        :page-size="pageSize"
        :pager-count="5"
        :current-page.sync="currentPage"
        layout="total, sizes, prev, pager, next"
        @size-change="changeSize"
        @current-change="changePage"
      ></el-pagination>
    </div>
    <add-text v-if="showAdd" @click="addTable"></add-text>
    <el-pagination
      v-if="showMin"
      class="x-samll-pagination"
      :total="total"
      :pager-count="5"
      :page-size="pageSize"
      layout="prev, pager, next"
      :current-page.sync="currentPage"
      @current-change="changePage"
    ></el-pagination>
  </div>
</template>

<script>
import Cell from './render.js';
import i18n from '@/i18n/index.js';
import AddText from './addText.vue';
export default {
  name: 'MyTable',
  components: {
    Cell,
    AddText
  },
  props: {
    maxHeight: '', // 最大高度
    height: '', // 高度
    showAdd: {
      // 是否显示新增按钮
      type: Boolean,
      default: false
    },
    removeHeaderBg: {
      // 是否去除表头背景色
      type: Boolean,
      default: false
    },
    xborder: {
      // 外边框
      type: Boolean,
      default: false
    },
    selection: {
      // 可勾选
      type: Boolean,
      default: false
    },
    highlightCurrentRow: {
      // 高亮当前行
      type: Boolean,
      default: false
    },
    index: {
      // 索引
      type: Boolean,
      default: false
    },
    tableData: {
      // 表格数据
      type: Array,
      default: () => {
        return [];
      }
    },
    showPage: {
      // 显示分页
      type: Boolean,
      default: true
    },
    emptyText: {
      type: String,
      default: () => i18n.t('HT.nodata')
    },
    showMin: {
      // 显示mini分页
      type: Boolean,
      default: false
    },
    total: {
      // 总条数
      type: Number,
      default: 0
    },
    columns: {
      // 表头数据
      type: Array
    },
    sizes: {
      // 页容量
      type: Array,
      default: () => {
        return [10, 20, 50];
      }
    },
    current: {
      // 当前页
      type: Number,
      default: 1
    },
    pageSize: {
      // 当前页容量
      type: Number,
      default: 10
    },
    rowKey: {
      type: String
    },
    treeProps: {
      type: Object,
      default: () => {
        return {
          children: 'children',
          hasChildren: 'hasChildren'
        };
      }
    }
  },

  data() {
    return {
      currentPage: this.current
    };
  },

  methods: {
    rowClassName({ row, rowIndex }) {
      row.index = rowIndex; //把每一行的索引放进row
    },

    /**
     * 选择项发生变化时会触发该事件
     * @param {Array} selection 选择项
     */
    selectionChange(selection) {
      this.$emit('changeSelect', selection);
    },

    /**
     * 勾选全选 Checkbox 时触发的事件
     * @param {Array} selection 选择项
     */
    selectAll(selection) {
      this.$emit('selectAll', selection);
    },

    /**
     * 勾选数据行的 Checkbox 时触发的事件
     * @param {Array} selection 选择项
     * @param {Object} row 当前行数据
     */
    select(selection, row) {
      this.$emit('select', selection, row);
    },

    /**
     * 点击当前行事件
     * @param {Object} row 当前行数据
     */
    rowClick(row, column, event) {
      this.$emit('rowClick', row, column, event);
    },

    /**
     * 新增表格行
     */
    addTable() {
      this.$emit('addTable');
    },

    /**
     * 切换页码
     * @param {Number} val 返回的页码
     */
    changePage(val) {
      this.$emit('changePage', val);
    },

    /**
     * 切换页容量
     * @param {Number} val 返回的页容量
     */
    changeSize(val) {
      this.$emit('changeSize', val);
    }
  },
  watch: {
    current: {
      handler(val) {
        this.currentPage = val;
      }
    },
    currentPage: {
      handler(val) {
        this.$emit('update:current', val);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.table-components {
  position: relative;
  max-height: 100%;

  .el-table {
    position: relative;
    width: 100%;
    background-color: #fff;
  }

  .pagination {
    padding: 30px 0;
    text-align: center;

    .total-box {
      position: absolute;
      float: left;
      height: 30px;
      line-height: 30px;
      color: #1d2944;

      .total {
        font-size: 20px;
        margin: 0 5px;
      }
    }
  }

  .table-icon {
    display: flex;
    justify-content: center;
    width: 60px;
    height: 60px;
    overflow: hidden;
    border-radius: 50%;
    text-align: center;

    .icon-img {
      width: 100%;
      height: 100%;
      background-color: transparent;
    }
  }
}
</style>

<style lang="scss">
.table-components {
  .el-table th {
    font-weight: 600;
    color: #1d2944;
    border: 0 none;
    background-color: transparent;
  }

  // 修改表格头样式
  .el-table__header-wrapper {
    flex: 0 0 48px; // 占比

    .el-table__header {
      border-bottom: 1px solid #d7dde780;

      th {
        background-color: #f3f4f7;
      }
    }
  }

  // 表内容
  .el-table__body-wrapper {
    flex: 1;
  }

  // 表格滚动条优化
  .el-table--scrollable-y .el-table__body-wrapper {
    .el-table__body {
      width: 100% !important;
    }

    // 定义滚动条宽度
    &::-webkit-scrollbar {
      width: 5px;
    }

    // 定义滚动条轨道
    &::-webkit-scrollbar-track {
      border-radius: 10px;
      background-color: #f0f0f0;
    }

    // 定义滚动条滑块
    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      background-color: #dddee0;
    }
  }

  .el-table--scrollable-y .el-table__header .has-gutter > tr > th:nth-last-child(2) .cell {
    margin-left: 9px;
  }

  // 固定列的样式-去掉边线
  .el-table__fixed::before,
  .el-table__fixed-right::before {
    background-color: transparent;
  }

  .el-table__fixed-header-wrapper .el-table__header th {
    background-color: #f3f4f7;
  }

  .el-table__fixed-body-wrapper {
    top: 48px !important;
    bottom: 0;
  }

  .el-table__empty-text {
    color: #777f8f;
  }

  .x-border-color:before {
    // 边框表格优化样式
    height: 0;
  }

  .x-border-color tbody > tr:last-child > td {
    border: 0 none;
  }

  // 右上角小方块
  .el-table__fixed-right-patch {
    background-color: #f3f4f7;
  }

  // 高亮
  .el-table__body tr.current-row > td {
    color: #0087ff;
  }
}

.x-table-blue-btn {
  margin: 0 5px;
  color: #0087ff;
  cursor: pointer;
}

.x-table-green-text {
  color: #02c548;
}

.x-table-blue-text {
  color: #0087ff;
}

.x-table-red-text {
  color: #ed003d;
}

// 在表格第一行插入输入框
.x-table-add-style {
  .el-table__body-wrapper {
    .el-table__row {
      position: relative;
      height: 50px;

      > td {
        display: none;
      }

      > td:first-child {
        display: table-cell;
        position: absolute;
        height: 50px;
        width: 100%;

        > .cell {
          position: absolute;
          right: 0;
          left: 0;
          top: 0;
          bottom: 0;
          padding: 0;
          background-color: #fff;
        }
      }

      .el-form-item {
        margin-bottom: 0;
      }
    }

    .el-table__row .cell {
      overflow: visible;
    }
  }
}

// 去除表头背景色
.remove-header-bg {
  .el-table__header-wrapper .el-table__header th {
    background-color: transparent;
  }
}
</style>
